import { render, staticRenderFns } from "./FinalDocumentUpload.vue?vue&type=template&id=804563b0&scoped=true"
import script from "./FinalDocumentUpload.vue?vue&type=script&lang=js"
export * from "./FinalDocumentUpload.vue?vue&type=script&lang=js"
import style0 from "./FinalDocumentUpload.vue?vue&type=style&index=0&id=804563b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804563b0",
  null
  
)

/* custom blocks */
import block0 from "./FinalDocumentUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports